/**
 * UI preferences (Zustand, persisted) — desktop layout choices the user sets
 * and the app remembers across reloads. Today that's the Home sidebar
 * (patient / context rail) collapse state, mirroring Apple Mail's "Hide
 * Sidebar": collapse the rail to hand its width to the conversation list +
 * detail view. Persisted to localStorage via the same idiom as the auth /
 * config stores.
 */
import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

interface UIPrefsState {
  /** Home patient/context rail collapsed? Default false — visible, the
   *  patient-first workflow starts from the rail. */
  sidebarCollapsed: boolean
  toggleSidebar: () => void
  setSidebarCollapsed: (collapsed: boolean) => void
}

export const useUIPrefsStore = create<UIPrefsState>()(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
      setSidebarCollapsed: (sidebarCollapsed) => set({ sidebarCollapsed }),
    }),
    {
      name: 'tricorder-ui-prefs',
      storage: createJSONStorage(() => localStorage),
    },
  ),
)
